import { forwardRef } from 'react';

import type { TpModalProps } from '@mentalgrowth/ui-kit-web';
import UiKitModal from 'src/components/common/ui-kit-modal';

type TpModalContainerProps = TpModalProps & {
  className?: string;
  dialogClassName?: string;
};

const ModalContainer = forwardRef<HTMLDivElement, TpModalContainerProps>(
  ({ className, dialogClassName, ...props }: TpModalContainerProps, ref) => (
    <UiKitModal {...props} ref={ref} />
  ),
);

export default ModalContainer;
